<template>
    <div class="area-content" style="position: relative">
      <div ref="area" class="mainArea">      
        <div class="order-box">
          <p class="order-title" style="text-align: center;">中健收样APP服务协议</p>
          <p class="order-info"><span>感谢您选择注册并使用中健收样，在使用中健收样服务前，</span>
			<span style="font-weight: 700;">请您认真阅读本协议（特别是以加粗方式提示您注意的可能存在免除或限制责任等重要内容的条款），并确认承诺同意遵守本协议之全部约定。</span>
			<span>本协议由您与上海中健佳益健康管理有限公司（包括其关联机构，以下合称“本公司”）于您点击同意本协议之时在江苏省南京市浦口区签署并生效。</span></p>

            <p class="order-info">  一 协议条款的确认及接受</p>
            <p class="order-info">  1. 中健收样由上海中健佳益健康管理有限公司（包括其关联机构，以下合称“本公司”）运营并享有完全的所有权及知识产权等权益，中健收样提供的服务将完全按照其发布的条款及操作规则严格执行。</p>
            <p class="order-info">  2.
			您确认同意本协议（协议文本包括《中健收样用户服务协议》及中健收样已公示或将来公示的各项规则及提示，所有签署协议、规则及提示乃不可分割的整体，具有同等法律效力，共同构成用户使用中健收样及相关服务的整体协议，以下合称“本协议”）所有条款并完成注册程序时，本协议在您与本公司间成立并发生法律效力，同时您成为中健收样正式用户。</p>
            <p class="order-info">  二 账号注册及使用规则</p>
            <p class="order-info">  1. 您注册成功后，中健收样将给与您一个用户账户，该用户账号由您负责保管；您应当对以其用户账号进行的所有活动和事件负法律责任。</p>
            <p class="order-info">  2.
			您须对在中健收样的注册信息的真实性、合法性、有效性承担全部责任，您不得冒充他人（包括但不限于冒用他人姓名、头像、字号等足以引起混淆的方式）开设账号；不得恶意使用注册账户导致其他用户误认；否则中健收样有权立即停止提供服务，收回其账号并由您独自承担由此产生的一切法律责任。</p>
        
            <p class="order-info">  <span>3. 您理解且确认，您在中健收样注册账号的所有权及有关权益均归本公司所有，您完成注册手续后仅享有该账号的使用权。</span>
			<span style="font-weight: 700;">您的账号仅限于您本人使用，</span>
			<span>未经本公司书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果本公司发现或者有合理理由认为使用者非账号初始注册人，公司有权在未通知您的情况下，暂停或终止向该注册账号提供服务，并有权注销账号，而无需向注册该账号的用户承担法律责任。</span></p>
            <p class="order-info">  4.
			您理解并确认，除登录、使用中健收样及相关服务外，您还可以使用中健收样账号登陆使用本公司及其关联方或其他合作方提供的其他软件、服务；同时，若您在相应的软件、服务中确认相关内容同步功能的，则您在前述软件中发布的内容及相关数据将同步至您的中健收样账号中。您以中健收样账号登录并使用前述服务的，同样应受其他软件、服务实际提供方的用户协议及其他协议条款约束。</p>
       
            <p class="order-info"> 5. 您承诺不得以任何方式利用中健收样直接或间接从事违反中国法律、以及社会公德的行为，中健收样有权对违反前述承诺的内容予以删除。</p>
            <p class="order-info"> 6. 您不得在本网站制作、上载、复制、发布、传播或者转载如下内容：</p>
            <div class="order-info"> 1) 违反宪法所确定的基本原则的； </div>
            <div class="order-info">2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； </div>
            <div class="order-info">3) 损害国家荣誉和民族利益的；</div>
            <div class="order-info">4) 煽动民族仇恨、民族歧视、破话民族团结的；</div>
            <div class="order-info">5) 破坏国家宗教政策，宣扬邪教和封建迷信的；</div>
            <div class="order-info">6) 散布谣言，扰乱社会秩序，破坏社会稳定的；</div>
            <div class="order-info">7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</div>
            <div class="order-info">8) 侮辱或者诽谤他人，侵害他人合法权益的；</div>
            <div class="order-info">9) 违反医师执业许可规定、职业道德规范的；</div>
            <div class="order-info">10) 含有法律法规禁止的其他内容的信息。</div>
            <p class="order-info">  
			<span style="font-weight: 700;">您不应通过中健收样发布他人受知识产权保护的内容，除非获得他人的合法授权。</span>
			<span>就您发布的内容，若第三方向中健收样投诉并提交初步证据，经中健收样判断属实的，中健收样将删除这些内容。就因您发布的内容给中健收样带来损失的，您应当负责赔偿。</span></p>
            <p class="order-info"> 7. 未经本公司书面许可，您不得将中健收样上的我公司信息内容向非网站上的用户进行分享、转发等行为，不得进行任何形式的销售和商业使用，或向第三方提供或允许第三方为任何方式的使用。</p>
            <p class="order-info"> 	8.
			中健收样有权对您使用中健收样的情况进行审查和监督，如您在使用中健收样违反上述规定，中健收样或其授权的人有权要求您修改或直接采取一切必要的措施（包括但不限于更改或删除您登记的内容、暂停或终止您使用中健收样的权利）以减轻您的不当行为造成的影响。</p>
            <p class="order-info">三 服务内容</p>
            <p class="order-info">1. 本公司可能为不同的终端设备及使用需求开发不同的应用软件程序软件版本，您应当根据实际设备及需求获取、下载、安装适合的版本。</p>
            <p class="order-info">2.
			本网站的服务具体内容根据实际情况提供，中健收样保留变更、中断或终止部分或全部服务的权利。中健收样不承担因业务调整给您造成的损失。除非本协议另有其他明示的规定，增加或强化目前本网站的任何新功能，包括所推出的新产品，均受到本协议之规范。您理解并同意，本网站服务仅依其当前所呈现的状况提供，对于任何用户通讯或个人化设定之时效、删除、传递错误、未予储存或其他任何问题，中健收样均不承担任何责任。若您不接受服务调整，请停止使用本服务；否则，您的继续使用行为则将被视为其对调整服务的完全同意且承诺遵守。</p>
            <p class="order-info"><span>3. 您理解，</span>
			<span style="font-weight: 700;">中健收样仅提供相关服务，</span>
			<span>除此之外与相关服务有关的设备（如电脑、手机及其他与接入互联网有关的装置）及手续的费用（如为接入互联网而支付的电话费及上网费）均应由您自行负担。</span></p>
            <p class="order-info">4.
			中健收样提供的服务内容可能包括：签到、日报、周报、本月指标、完成情况等。所有这些内容受著作权、商标和其他财产所有权法律的保护。您只有在获得中健收样或其他相关权利人的授权之后才能使用这些内容，不得擅自复制、再造这些内容、或创造与内容有关的衍生产品。</p>
       
            <p class="order-info">  四 知识产权</p>
            <p class="order-info">  1.
			本公司在“中健收样”软件就相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、商标、标识、音频、视频、图表、版面设计、电子文档等）的知识产权归属本公司所有。同时本公司提供服务所依托的软件的著作权、专利权、商标及其他知识产权均归本公司所有。未经本公司书面许可，任何人不得擅自使用。</p>
            <p class="order-info">  2.
			请您在任何情况下都不要私自使用公司的包括但不限于“中健佳益”、“医知检”、“中健收样”等在内的任何商标、服务标记、网站名称或其他显著品牌特征（以下统称为“标识”）。未经公司事先书面同意，您不得将本条款前述标识以单独或结合其他方式展示、使用或申请注册商标等，也不得实施向他人明示或暗示有权展示、使用或有其他处理这些标识的行为。</p>
            <p class="order-info"> 	3. 由于您违反本协议使用上述商标、标识等给本公司或他人造成损失的，由您承担全部法律责任。</p>
           
            <p class="order-info">  五 用户授权及隐私护</p>
            <p class="order-info">  1. 保护用户隐私是中健收样的一项基本政策，中健收样保证不对外公开或向第三方提供您和家庭成员（若有）的注册资料等及您在使用本网站服务时储存在中健收样的非公开内容，但下列情况除外：</p>
            <div class="order-info"> 1) 事先获得您的明确授权； </div>
            <div class="order-info">2) 根据有关的法律法规要求； </div>
            <div class="order-info">3)为维护社会公众的利益；</div>
            <div class="order-info">4) 维护中健收样的合法权益。</div>
            <p class="order-info">  2. 在获得您授权的情况下，中健收样可能会与第三方合作向您提供相关服务。在此情况下，如该第三方同意承担与中健收样同等的保护用户隐私的责任，则中健收样可将您的注册资料等提供给该第三方。</p>
            <p class="order-info">  3.
			您理解并承诺，您使用中健收样软件及相关服务时发布上传的内容（包括但不限于文字、图片、视频、语音等形式的内容及其中包含的文字、音乐、声音、台词、视觉设计等所有组成部分）均由您原创或已获合法授权。您通过中健收样上传、发布所产生的内容的知识产权归属您或原始著作权人所有。</p>
            <p class="order-info"> 4. 在不透露单个用户隐私资料的前提下，中健收样有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>
            <p class="order-info"> 	5. 中健收样将采取合法先进的技术手段、严密的内控制度等保护用户的隐私信息。</p>    
            <p class="order-info"> 	6. 您可以向中健收样申请注销账户。账户注销后，中健收样将停止为您提供服务，并依据您的要求，除法律另有规定外，中健收样将删除其在中健收样平台上的个人信息。</p>
      
            <p class="order-info">  六 免责声明</p>
            <p class="order-info"> 	1.
			您将个人信息等资料上传到互联网上，有可能会被其他组织或个人复制、转载、擅改或做其他非法用途，用户必须充分意识到此类风险的存在。您明确同意其使用中健收样服务所存在的风险（包括但不限于收到第三方侵权或对第三方造成侵权）完全由您自己承担；因您使用中健收样服务而产生的一切后果也由您自己承担，中健收样对此不承担任何责任。</p>
            <p class="order-info"> 2. 中健收样不担保本网站服务一定能满足您的要求，也不担保本网站服务不会中断，对本网站服务的及时性、安全性、准确性、真实性、完整性也都不做担保。   </p>
            <p class="order-info"> 3. 对因不可抗力或中健收样不能控制的原因造成的本网站服务中断或其他缺陷，中健收样不承担任何责任，但中健收样将尽力减少因此给您带来的损失和影响。   </p>
            <p class="order-info"><span>4. 根据有关法律法规，中健收样在此郑重提请您注意，中健收样作为信息储存及展示空间和网络交易的提供者，任何经由本网站传送的内容，无论是公开还是私下传送，均由内容提供者承担责任。</span>
			<span style="font-weight: 700;">中健收样无法控制经由本网站传送之内容，因此不保证内容的正确性、完整性或品质。</span>
			<span>在任何情况下，中健收样均不为任何内容负责，但中健收样有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停服务，保存有关记录，并向有关机关报告。</span>    </p>
            <p class="order-info"> 5. 您使用本网站服务的全部或部分，中健收样将根据法律规定保存有关记录，并向有关机关报告。</p>
            <p class="order-info"> 6. 中健收样作为网络服务提供者，对非法转载、虚假发布、盗版行为的发生不具备充分的监控能力。中健收样对他人在网站上实施的此类侵权行为不承担法律责任，侵权的法律责任概由本人承担。   </p>
            <p class="order-info"> 七 违约责任   </p>
            <p class="order-info"> 1.
			针对您违反本协议的行为，本公司有权独立判断并视情况采取预先警示、立即停止传输信息、删除内容、限制账号部分或全部功能直至永久关闭账号等措施。对涉嫌违反法律法规的行为将保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。   </p>
            <p class="order-info"> 2.
			因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行承担全部法律责任。因您的违约或违反行为导致本公司及其关联公司、控制公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿本公司及其关联公司、控制公司因此遭受的全部损失。   </p>
            <p class="order-info">八 协议修改</p>
            <p class="order-info">1. 中健收样有权根据法律法规政策、国家有权机构或公司经营要求修改本协议的有关条款，中健收样将会通过适当的方式在网站上予以公示。    </p>
            <p class="order-info">2. 若您不同意中健收样对本协议相关条款的修改，您有权停止使用本网站服务。如果您继续使用本网站服务，则事为您接受中健收样对本协议相关条款所做的修改。   </p>
            <p class="order-info">九 法律管辖使用及其他    </p>
            <p class="order-info"> 1. 如您与本公司就协议订立、执行和解释及争议的解决均适用中华人民共和国法律。如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商解决不成时，任何一方均应向协议签署地人民法院提起诉讼。   </p>
            <p class="order-info">2. 如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且不影响任何其余条款的有效性和可执行性。    </p>

        </div>          
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'syPrivacy',
    data: function () {
      return {
        
      };
    },
    mounted() {},
    methods: { }
  };
  </script>
  
  <style lang="scss" scoped>
  // /deep/ #app {
  //   overflow: auto !important;
  // }
  .area-content {
    height: 100vh;
    width: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
  }
  .mainArea {
    // position: absolute;
    // top: 1000px;
    // left: 0;
    width: 414px;
    height: auto;
    // border: 1px solid red;
    box-sizing: border-box;
    background-color: #f6f6f6;
    padding: 5px 10px;
    .patient-box {
      width: 100%;
      height: 77px;
      border-radius: 6px;
      background-color: #fff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 10px;
      box-sizing: border-box;
      .head-pic {
        width: 55px;
        height: 55px;
        //  border: 1px solid red;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .patient-info {
        margin-left: 20px;
        // height: 55px;
        // display: flex;
        // flex-direction: column;
        // border: 1px solid red;
        p {
          font-size: 14px;
        }
      }
    }
    .order-box {
      width: 100%;
      height: auto;
      padding: 10px 10px;
      border-radius: 6px;
      background-color: #fff;
      box-sizing: border-box;
      // border: 1px solid red;
      margin-top: 20px;
      .order-title {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #333333;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .order-info {
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        text-align: left;
        color: #333333;
        margin-bottom: 6px;
        white-space: normal;
        word-break: break-all;
      }
    }
    .project-box {
      width: 100%;
      height: auto;
      padding: 10px 10px;
      border-radius: 6px;
      background-color: #fff;
      box-sizing: border-box;
      margin-top: 20px;
      .project-title {
        width: 100%;
        min-height: 40px;
        padding: 10px 0;
        box-sizing: border-box;
        // border: 1px solid red;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #0087ff;
        font-size: 18px;
        font-weight: bold;
        white-space: normal;
        word-break: break-all;
      }
      .project-single {
        width: 100%;
        min-height: 46px;
        // border: 1px solid red;
        display: flex;
        align-items: center;
        // justify-content: center;
        color: #333333;
        font-size: 14px;
        background: #d7eeff;
        padding: 5px 0 5px 5px;
        box-sizing: border-box;
        .single-left {
          width: 170px;
          min-height: 40px;
          // border: 1px solid red;
          display: flex;
          align-items: center;
          white-space: normal;
          word-break: break-all;
        }
        .single-middle {
          width: 120px;
          min-height: 40px;
          // border: 1px solid red;
          display: flex;
          align-items: center;
          white-space: normal;
          word-break: break-all;
        }
        .single-right {
          width: 120px;
          min-height: 40px;
          // border: 1px solid red;
          display: flex;
          align-items: center;
          white-space: normal;
          word-break: break-all;
        }
      }
    }
    .report-box {
      width: 100%;
      height: auto;
      padding: 10px 0px;
      border-radius: 6px;
      background-color: #fff;
      box-sizing: border-box;
      margin-top: 20px;
      .report-header {
        height: 40px;
        width: 100%;
        text-align: center;
        line-height: 45px;
        color: #0087ff;
        font-size: 18px;
        font-weight: bold;
      }
      .repotr-content {
        width: 100%;
        margin-bottom: 20px;
        .project-single {
          width: 100%;
          // border: 1px solid red;
          display: flex;
          align-items: center;
          // justify-content: center;
          color: #333333;
          font-size: 14px;
          background: #e8eaec;
          padding: 5px 0 5px 5px;
          box-sizing: border-box;
          .single-left {
            width: 260px;
            min-height: 30px;
            // border: 1px solid red;
            display: flex;
            align-items: center;
          }
          .single-middle {
            width: 120px;
            min-height: 30px;
            // border: 1px solid red;
            display: flex;
            align-items: center;
          }
          .single-right {
            width: 34px;
            min-height: 30px;
            // border: 1px solid red;
            display: flex;
            align-items: center;
          }
        }
        .project-describe {
          width: 100%;
          padding: 10px 10px;
          // border: 1px solid red;
          color: #8e8c8c;
          font-size: 14px;
          box-sizing: border-box;
        }
      }
    }
  }
  .imgBox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #eee;
    color: #607d8b;
    text-align: center;
    z-index: 10000;
    .imgMain {
      position: relative;
      margin: 0;
      padding: 0 0 15px 0;
      width: 100%;
      max-width: 750px;
      min-width: 300px;
      height: auto;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      p {
        padding: 10px 0px;
      }
      .canvasImg {
        max-height: 650px;
        position: relative;
        margin-left: 15px;
        margin-right: 15px;
        overflow-x: hidden;
        overflow-y: auto;
        img {
          width: 100%;
          height: auto;
          background: #525252;
        }
      }
    }
  }
  </style>
  